import React from 'react';
import { BookingWizardTab } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/BookingWizard';
import { BookingWizardData } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/BookingWizardData/BaseBookingWizardData';
import { FerryBackButton } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/BottomBar/FerryBackButton';
import { FerryContinueButton } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/BottomBar/FerryContinueButton';
import { AcceptTandCsCheckbox } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/WizardSteps/Cart/AcceptTandCsCheckbox';

import { useBookingWizardDataStore } from '../BookingWizardDataStore';
import { BookingWizardTabNames } from '../BookingWizardConstants';

export interface FerryBookingWizardBottomBarProps {
	tabs: BookingWizardTab[];
	currentTabIndex: number;
	onClickContinue: () => void;
	onClickBack: () => void;
	isIpad: boolean;
	onTimerExpiry: () => void;
	ticketsPageUrl: string;
	continueBtnText?: string;
	continueBtnLoadingText?: string;
	continueBtnProps?: React.ButtonHTMLAttributes<Element>;
	disableContinueButton: boolean;
	tabIsLoading: boolean;
}

export function FerryBookingWizardBottomBar({
	tabs,
	currentTabIndex,
	onClickContinue,
	onClickBack,
	isIpad,
	onTimerExpiry,
	ticketsPageUrl,
	continueBtnText,
	continueBtnLoadingText,
	continueBtnProps,
	disableContinueButton,
	tabIsLoading,
}: FerryBookingWizardBottomBarProps) {
	const { wizardData, setWizardData } = useBookingWizardDataStore();
	const currentTab = tabs[currentTabIndex];
	const showTsAndCs = currentTab.showTAndCsButton;

	const backButton = () => {
		if (showTsAndCs) {
			const { checkboxProps } = tabs[currentTabIndex];

			const checked = (() => {
				if (checkboxProps !== undefined) {
					return checkboxProps.checked;
				}
				return wizardData.acceptedTsAndCs;
			})();

			const setChecked = (newChecked: boolean) => {
				if (checkboxProps) {
					checkboxProps.toggle();
					return;
				}
				const newData = new BookingWizardData({ ...wizardData });
				newData.acceptedTsAndCs = newChecked;
				setWizardData(newData);
			};

			return <AcceptTandCsCheckbox checked={checked} setChecked={setChecked} />;
		}

		const isDisabled = shouldDisabledBackButton(currentTab.name, wizardData.innerWizardData.type);

		return (
			<FerryBackButton
				isDisabled={isDisabled}
				onClick={onClickBack}
				tabs={tabs}
				currentTabIndex={currentTabIndex}
				isIpad={isIpad}
				onTimerExpiry={onTimerExpiry}
				ticketsPageUrl={ticketsPageUrl}
				forEventBooking={false}
			/>
		);
	};

	const continueButton = () => {
		const continueDisabled = (() => {
			if (showTsAndCs) {
				// Need to disable continue while checkbox is unticked
				const { checkboxProps } = tabs[currentTabIndex];
				if (checkboxProps) {
					return !checkboxProps.checked || disableContinueButton;
				}
				return !wizardData.acceptedTsAndCs || disableContinueButton;
			}

			return disableContinueButton;
		})();

		return (
			<FerryContinueButton buttonProps={continueBtnProps} onClick={onClickContinue} disabled={continueDisabled}>
				{tabIsLoading ? continueBtnLoadingText : continueBtnText}
			</FerryContinueButton>
		);
	};

	return (
		<div className="booking-wizard-step-bottom-bar">
			<div className="booking-wizard-step-btn-group bottom-navigation-btn-group">
				{backButton()}
				{continueButton()}
			</div>
		</div>
	);
}

const shouldDisabledBackButton = (tabName: string, type: 'vehicle' | 'passenger' | 'freight') => {
	// If the last edited booking is freight, disable back button in cart
	const inCartTab = tabName === BookingWizardTabNames.Cart;
	const hasFreightBooking = type === 'freight';
	return inCartTab && hasFreightBooking;
};
